import React, { useEffect, useRef, useState } from "react";
import axiosInstance, { serverURL } from "../../services/FetchNodeServices";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import html2pdf from "html2pdf.js";
import CallBackImg from "../../services/DBSLOGO.jpg";
import IMAGES from "../../services/noImage.png";

// ─── Currency Helper ───────────────────────────────────────────────────────────
// const getOrderCurrency = (order) => {
//   // Priority: currency field > country code
//   const currency = (order?.currency || "");
//   console.log("currencySSSDDD:=>", currency)

//   if (currency === "INR") return "INR";
//   if (currency === "EUR") return "EUR";
//   if (currency === "GBP") return "GBP";
//   return "USD"; // default
// };

const getOrderCurrency = (order) => {
  const currency = order?.currency || "";
  if (currency === "INR") return "INR";
  if (currency === "EUR") return "EUR";
  if (currency === "GBP") return "GBP";
  return "USD";
};

// const formatPrice = (dollarAmount, order, decimals = 2) => {

//   const currency = getOrderCurrency(order);
//   console.log("XXXSSSX+=>", currency, order)
//   const rate = order?.dollarPriceAtOrder || 1;
//   const amount = parseFloat(dollarAmount || 0);

//   switch (currency) {
//     case "INR": {
//       // For INR: rate means "1 USD = rate INR", so multiply
//       const inr = Math.ceil(amount * rate);
//       return `₹${inr.toLocaleString("en-IN")}`;
//     }
//     case "EUR": {
//       // For EUR: rate means "1 USD = rate EUR", so divide to get EUR from USD
//       // BUT if dollarPriceAtOrder < 1, it means USD/EUR rate (e.g. 0.84 EUR per USD)
//       // So EUR amount = dollarAmount * rate  (123 USD * 0.84 = ~103 EUR) 
//       // Check your backend logic — adjust the operator if needed
//       const eur = (amount * rate).toFixed(decimals);
//       return `€${eur.toLocaleString("en-DE")}`;
//     }
//     case "GBP": {
//       const gbp = (amount * rate).toFixed(decimals);
//       return `£${gbp.toLocaleString("en-GB")}`;
//     }
//     default:
//       return `$${amount.toFixed(decimals)}`;
//   }
// };

// ─── Format total order amount ────────────────────────────────────────────────

const formatPrice = (dollarAmount, order, decimals = 2) => {
  const currency = getOrderCurrency(order);
  const rate = order?.dollarPriceAtOrder || 1;
  const amount = parseFloat(dollarAmount || 0);
  switch (currency) {
    case "INR": return `₹${Math.ceil(amount * rate).toLocaleString("en-IN")}`;
    case "EUR": return `€${(amount * rate).toFixed(decimals)}`;
    case "GBP": return `£${(amount * rate).toFixed(decimals)}`;
    default: return `$${amount.toFixed(decimals)}`;
  }
};

// const formatTotal = (order) => {
//   const currency = getOrderCurrency(order);
//   const total = parseFloat(order?.totalAmount || 0);
//   const rate = order?.dollarPriceAtOrder || 1;

//   switch (currency) {
//     case "INR": {
//       const inr = Math.ceil(total * rate);
//       return `₹${inr.toLocaleString("en-IN")}`;
//     }
//     case "EUR": {
//       const eur = (total * rate).toFixed(2);
//       return `€${eur.toLocaleString("en-DE")}`;
//     }
//     case "GBP": {
//       const gbp = (total * rate).toFixed(2);
//       return `£${gbp.toLocaleString("en-GB")}`;
//     }
//     default:
//       return `$${total.toFixed(2)}`;
//   }
// };

// ─── Currency symbol helper (for badges, labels etc.) ────────────────────────

const formatTotal = (order) => {
  const currency = getOrderCurrency(order);
  const total = parseFloat(order?.totalAmount || 0);
  const rate  = order?.dollarPriceAtOrder || 1;
  switch (currency) {
    case "INR": return `₹${Math.ceil(total * rate).toLocaleString("en-IN")}`;
    case "EUR": return `€${(total * rate).toFixed(2)}`;
    case "GBP": return `£${(total * rate).toFixed(2)}`;
    default:    return `$${total.toFixed(2)}`;
  }
};

// const formatDate = (dateString) => {
//   if (!dateString) return "N/A";
//   return new Date(dateString).toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" });
// };

// const getCurrencySymbol = (order) => {
//   const map = { INR: "₹", EUR: "€", GBP: "£", USD: "$" };
//   return map[getOrderCurrency(order)] || "$";
// };

// // ─── Currency Badge component ─────────────────────────────────────────────────
// const CurrencyBadge = ({ order }) => {
//   const currency = getOrderCurrency(order);
//   const styles = {
//     INR: { background: "#fff3cd", color: "#856404" },
//     EUR: { background: "#cfe2ff", color: "#084298" },
//     GBP: { background: "#d1e7dd", color: "#0f5132" },
//     USD: { background: "#d1ecf1", color: "#0c5460" },
//   };
//   const s = styles[currency] || styles.USD;
//   return (
//     <span style={{
//       ...s,
//       fontSize: "10px",
//       padding: "1px 6px",
//       borderRadius: "4px",
//       fontWeight: 700,
//       marginLeft: 4,
//     }}>
//       {currency}
//     </span>
//   );
// };

// ─── Status badge ─────────────────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const cls = {
    Confirmed: "ao-badge-confirmed",
    Cancelled: "ao-badge-cancelled",
    Pending:   "ao-badge-pending",
    Shipped:   "ao-badge-shipped",
    Delivered: "ao-badge-delivered",
  }[status] || "ao-badge-default";
  return <span className={`ao-badge ${cls}`}>{status || "—"}</span>;
};

// ─── Currency badge ───────────────────────────────────────────────────────────
const CurrencyBadge = ({ order }) => {
  const currency = getOrderCurrency(order);
  const cls = { INR: "ao-currency-inr", EUR: "ao-currency-eur", GBP: "ao-currency-gbp", USD: "ao-currency-usd" }[currency] || "ao-currency-usd";
  return <span className={`ao-currency-badge ${cls}`}>{currency}</span>;
};

const AllOrder = () => {
  const [orders, setOrders] = useState([]);
  const [pdfOrder, setPdfOrder] = useState(null);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterOption, setFilterOption] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const invoiceRef = useRef(null);
  const [reviews, setReviews] = useState([]);


  // Fetch orders
  const fetchOrders = async () => {
    try {
      const response = await axiosInstance.get(
        "/api/v1/order/get-all-orders-admin"
      );
      if (response.status === 200) {
        const reversed = response?.data.orders?.reverse();
        setOrders(reversed);
        setFilteredOrders(reversed);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error("Failed to fetch orders.");
    }
  };

  // Delete order
  const deleteOrder = async (orderId) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });

      if (confirmation.isConfirmed) {
        const response = await axiosInstance.delete(
          `/api/v1/order/delete-order/${orderId}`
        );
        if (response?.status === 200) {
          const updated = orders.filter((order) => order._id !== orderId);
          setOrders(updated);
          setFilteredOrders(updated);
          setSelectedOrders((prev) => prev.filter((id) => id !== orderId));
          toast.success("Order deleted successfully.");
        }
      }
    } catch (error) {
      console.error("Error deleting order:", error);
      toast.error("Failed to delete order.");
    }
  };

  // Search
  const handleSearch = (e) => {
    const query = e.target.value?.toLowerCase();
    setSearchQuery(query);

    const filtered = orders.filter((order) => {
      const idMatch = order.orderUniqueId?.toLowerCase().includes(query);
      const emailMatch = order.shippingAddress?.email
        ?.toLowerCase()
        .includes(query);
      const nameMatch =
        order.shippingAddress?.firstName?.toLowerCase().includes(query) ||
        order.shippingAddress?.lastName?.toLowerCase().includes(query);
      return idMatch || nameMatch || emailMatch;
    });
    setFilteredOrders(filtered);
  };

  // Filter
  const handleFilterChange = (e) => {
    setFilterOption(e.target.value);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    let filtered = [...orders];

    const today = new Date();
    if (filterOption === "today") {
      filtered = filtered.filter(
        (order) =>
          new Date(order.createdAt).toDateString() === today.toDateString()
      );
    } else if (filterOption === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      filtered = filtered.filter(
        (order) =>
          new Date(order.createdAt).toDateString() === yesterday.toDateString()
      );
    } else if (filterOption === "thisWeek") {
      const startOfWeek = new Date();
      startOfWeek.setDate(today.getDate() - today.getDay());
      filtered = filtered.filter(
        (order) => new Date(order.createdAt) >= startOfWeek
      );
    } else if (filterOption === "thisMonth") {
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      filtered = filtered.filter(
        (order) => new Date(order.createdAt) >= startOfMonth
      );
    } else if (filterOption === "thisYear") {
      const startOfYear = new Date(today.getFullYear(), 0, 1);
      filtered = filtered.filter(
        (order) => new Date(order.createdAt) >= startOfYear
      );
    }

    setFilteredOrders(filtered);
  }, [filterOption, orders]);

  // Handle checkbox selection
  const handleSelectOrder = (orderId) => {
    setSelectedOrders((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrders([]);
    } else {
      const allIds = filteredOrders.map((order) => order._id);
      setSelectedOrders(allIds);
    }
    setSelectAll(!selectAll);
  };

  // const handleDownloadSelected = () => {
  //   const selectedData = orders.filter((order) =>
  //     selectedOrders.includes(order._id)
  //   );

  //   if (selectedData.length === 0) {
  //     toast.warn("Please select at least one order.");
  //     return;
  //   }

  //   // ── Flatten: one ROW per item (not per order) ──────────────────────────────
  //   // Sample.xlsx format has one row per product, same order-id repeats
  //   const formattedData = [];
  //   let jacksonCounter = 1; // JACKSON = global serial across all items

  //   selectedData.forEach((order) => {
  //     const currency = getOrderCurrency(order); // "EUR" / "INR" / "USD"

  //     const purchaseDate = new Date(order.createdAt).toLocaleDateString("en-US", {
  //       month: "short", day: "2-digit", year: "numeric",
  //     }).toUpperCase(); // → "MAR 03, 2026"

  //     const platform = order.platform || "Delhi Bookstore";

  //     const items = order.items || [];

  //     items.forEach((item) => {
  //       const isbn13 = item.productId?.ISBN13 || item.ISBN13 || "N/A";
  //       const sku = isbn13 !== "N/A" ? `${isbn13}_DBS` : "N/A";
  //       const price = `${formatPrice(item?.productId?.finalPrice || item?.price || "0", item)}`;

  //       const shipping = item.shippingPrice || 0;

  //       formattedData.push({
  //         "S.No.": jacksonCounter++,
  //         "purchase-date": new Date(order?.createdAt).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }).toUpperCase().replace(",", ""),
  //         "PLATFORM": platform,
  //         "QTY": item.quantity || 1,
  //         "order-id": order.orderUniqueId || order._id,
  //         "product-name": item.productId?.title || item.name || "N/A",
  //         "ISBN-13": isbn13,
  //         "sku": sku,
  //         "currency": currency,
  //         "item-price": price,
  //         "shipping-price": shipping,
  //         "buyer-name": `${order.shippingAddress?.firstName || ""} ${order.shippingAddress?.lastName || ""}`.trim() || "N/A",
  //         "recipient-name": `${order.shippingAddress?.firstName || ""} ${order.shippingAddress?.lastName || ""}`.trim() || "N/A",
  //         "ship-address-1": order.shippingAddress?.address || "",
  //         "ship-address-2": order.shippingAddress?.address2 || "",
  //         "ship-city": order.shippingAddress?.city || "",
  //         "ship-state": order.shippingAddress?.state || "",
  //         "ship-postal-code": order.shippingAddress?.zipCode || order.shippingAddress?.postalCode || "",
  //         "ship-country": order.shippingAddress?.country || "IN",
  //         "buyer-phone-number": order.shippingAddress?.phone || "",
  //         "ship-phone-number": order.shippingAddress?.phone || "",
  //         "buyer-email": order.shippingAddress?.email || "",
  //       });
  //     });
  //   });

  //   // ── Build worksheet ────────────────────────────────────────────────────────
  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);

  //   // Column widths — same order as sample.xlsx headers
  //   worksheet["!cols"] = [
  //     { wch: 16 }, // purchase-date
  //     { wch: 16 }, // PLATFORM
  //     { wch: 10 }, // JACKSON
  //     { wch: 6 }, // QTY
  //     { wch: 28 }, // order-id
  //     { wch: 70 }, // product-name
  //     { wch: 16 }, // ISBN-13
  //     { wch: 20 }, // sku
  //     { wch: 10 }, // currency
  //     { wch: 14 }, // item-price
  //     { wch: 14 }, // shipping-price
  //     { wch: 22 }, // buyer-name
  //     { wch: 22 }, // recipient-name
  //     { wch: 35 }, // ship-address-1
  //     { wch: 25 }, // ship-address-2
  //     { wch: 18 }, // ship-city
  //     { wch: 18 }, // ship-state
  //     { wch: 16 }, // ship-postal-code
  //     { wch: 10 }, // ship-country
  //     { wch: 18 }, // buyer-phone-number
  //     { wch: 18 }, // ship-phone-number
  //     { wch: 35 }, // buyer-email
  //   ];

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  //   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //   const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(fileData, `Orders_${new Date().getTime()}.xlsx`);
  // };


  //   // ── Download XLSX ──────────────────────────────────────────────────────────
  
  
  const handleDownloadSelected = () => {
    const selectedData = orders.filter((o) => selectedOrders.includes(o._id));
    if (!selectedData.length) { toast.warn("Select at least one order."); return; }

    const formattedData = [];
    let counter = 1;
    selectedData.forEach((order) => {
      (order.items || []).forEach((item) => {
        const isbn13 = item.productId?.ISBN13 || item.ISBN13 || "N/A";
        formattedData.push({
          "S.No.": counter++,
          "purchase-date": new Date(order?.createdAt).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }).toUpperCase().replace(",", ""),
          "PLATFORM": order.platform || "Delhi Bookstore",
          "QTY": item.quantity || 1,
          "order-id": order.orderUniqueId || order._id,
          "product-name": item.productId?.title || item.name || "N/A",
          "ISBN-13": isbn13,
          "sku": isbn13 !== "N/A" ? `${isbn13}_DBS` : "N/A",
          "currency": getOrderCurrency(order),
          "item-price": formatPrice(item?.productId?.finalPrice || item?.price || "0", order),
          "shipping-price": item.shippingPrice || 0,
          "buyer-name": `${order.shippingAddress?.firstName || ""} ${order.shippingAddress?.lastName || ""}`.trim() || "N/A",
          "recipient-name": `${order.shippingAddress?.firstName || ""} ${order.shippingAddress?.lastName || ""}`.trim() || "N/A",
          "ship-address-1": order.shippingAddress?.address || "",
          "ship-address-2": order.shippingAddress?.address2 || "",
          "ship-city": order.shippingAddress?.city || "",
          "ship-state": order.shippingAddress?.state || "",
          "ship-postal-code": order.shippingAddress?.zipCode || order.shippingAddress?.postalCode || "",
          "ship-country": order.shippingAddress?.country || "IN",
          "buyer-phone-number": order.shippingAddress?.phone || "",
          "ship-phone-number": order.shippingAddress?.phone || "",
          "buyer-email": order.shippingAddress?.email || "",
        });
      });
    });

    const ws = XLSX.utils.json_to_sheet(formattedData);
    ws["!cols"] = [{ wch: 8 }, { wch: 16 }, { wch: 16 }, { wch: 6 }, { wch: 28 }, { wch: 70 }, { wch: 16 }, { wch: 20 }, { wch: 10 }, { wch: 14 }, { wch: 14 }, { wch: 22 }, { wch: 22 }, { wch: 35 }, { wch: 25 }, { wch: 18 }, { wch: 18 }, { wch: 16 }, { wch: 10 }, { wch: 18 }, { wch: 18 }, { wch: 35 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    saveAs(new Blob([XLSX.write(wb, { bookType: "xlsx", type: "array" })], { type: "application/octet-stream" }), `Orders_${Date.now()}.xlsx`);
  };

  const calculateTotalInINR = (order) => {
    return Math.ceil(order.totalAmount * order.dollarPriceAtOrder);
  };


  const downloadPDF = (order) => {
    setPdfOrder(order);

    setTimeout(() => {
      html2pdf()
        .set({
          margin: 0.5,
          filename: `${order.shippingAddress.firstName + " " + order.shippingAddress.lastName} - ${formatDate(order.createdAt)}.pdf`,
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "a4" },
        })
        .from(invoiceRef.current)
        .save();
    }, 200);
  };

  // Format date for invoice
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  useEffect(() => {
    const fetchReviews = async () => {
      // setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `/api/v1/feedback/get-all-feedback`
        );
        if (response?.data?.success === true) {
          setReviews(response?.data?.feedback || []);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
        toast.error("Failed to fetch reviews!");
      } finally {
        // setIsLoading(false);
      }
    };

    fetchReviews();
  }, []);

  const feedback = (id) => {
    const data = reviews.filter((item) => item?.orderId?._id === id);
    console.log("data ==>", data);
    return data;
  };

  const handleChangeStatus = async (e, order) => {
    const res = await axiosInstance.put(`/api/v1/order/update-order/${order?._id}`, { orderStatus: e.target.value });
    fetchOrders()
    console.log("DDDDD::=>", res);
  }


  console.log("filteredOrders:==>", IMAGES, CallBackImg);
  return (
    <>
      <ToastContainer />
      {/* <div>
        <img src={IMAGES} alt="CallBackImg" style={{ width: "100%" }} />
      </div> */}
      <div className="px-4 py-2 shadow-md rounded-md mb-2">
        {/* Header */}
        <div className="bread mb-3">
          <div className="head">
            <h4>All Orders</h4>
          </div>
        </div>
        {/* Filter & Search Row */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Filter & Download Section */}
          <div className="d-flex justify-content-between align-items-center gap-3">
            <select
              onChange={handleFilterChange}
              value={filterOption}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Orders</option>
              <option value="today">Today's Orders</option>
              <option value="yesterday">Yesterday's Orders</option>
              <option value="thisWeek">This Week's Orders</option>
              <option value="thisMonth">This Month's Orders</option>
              <option value="thisYear">This Year's Orders</option>
            </select>

            <div className="w-full md:w-72 gap-2 d-flex align-items-center">
              <input
                type="text"
                placeholder="Search by Order ID or Name..."
                value={searchQuery}
                onChange={handleSearch}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              <button
                type="button"
                className="btn btn-sm d-flex align-items-center gap-1 px-4 py-2 shadow-sm text-white"
                style={{ backgroundColor: "#840adc" }}
                onClick={handleDownloadSelected}
              >
                <i className="fas fa-download"></i> Download Selected
              </button>
            </div>
          </div>

          {/* Search Section */}
        </div>
      </div>

      <section className="main-table">
        <table className="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th className="align-middle">
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="me-2"
                  />
                  <span></span>
                </div>
              </th>
              <th>Sr.No.</th>
              <th>Order Detail</th>
              <th>Product Detail</th>
              <th>Paymant Detail</th>
              <th>Feedback</th>
              <th>Order Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders?.length > 0 ? (
              filteredOrders.map((order, index) => {
                return (<>
                  <tr key={order?._id}>
                    <td className="align-middle">
                      <input
                        type="checkbox"
                        checked={selectedOrders.includes(order._id)}
                        onChange={() => handleSelectOrder(order._id)}
                      />
                    </td>
                    <th scope="row" className="align-middle">
                      {index + 1}
                    </th>
                    <td className="align-middle">
                      <div
                        className="order-details"
                        style={{
                          width: "18vw",
                          maxHeight: "20vh",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        <div>
                          <strong>ID:</strong> {order.orderUniqueId}
                        </div>
                        <div>
                          <strong>Name:</strong>{" "}
                          {order.shippingAddress.firstName +
                            " " +
                            order.shippingAddress.lastName}
                        </div>
                        <div>
                          <strong>Email:</strong>{" "}
                          {order.shippingAddress?.email || "N/A"}
                        </div>
                        <div>
                          <strong>Phone:</strong>{" "}
                          {order.shippingAddress?.phone || "N/A"}
                        </div>
                        <div
                          style={{
                            fontSize: "14px",
                            marginBottom: "4px",
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          <div>
                            <strong>Address:</strong>{" "}
                            {order.shippingAddress.address},{" "}
                            {order.shippingAddress.city},{" "}
                            {order.shippingAddress.state}{" "}
                            {order.shippingAddress.zipCode}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td className="align-middle" style={{ width: "5%" }}>
                      <div
                        className="product-details-container"
                        style={{
                          width: "22vw",
                          maxHeight: "20vh",
                          overflowY: "auto",
                        }}
                      >
                        {/* scrollbarWidth: "none", msOverflowStyle: "none", */}
                        {order.items?.map((item, idx) => (
                          <div
                            key={idx}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              padding: "6px 0",
                              borderBottom: "1px solid #f0f0f0",
                            }}
                          >
                            {/* Product Image */}
                            <div
                              className="product-image me-2"
                              style={{
                                flex: "0 0 60px",
                                height: "80px",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={
                                  item?.productId?.images?.length > 0
                                    ? `${serverURL}/public/image/${item?.productId?.images[0]}` || IMAGES
                                    : IMAGES || CallBackImg
                                }
                                alt={"Product"}
                                className="img-thumbnail"
                                style={{
                                  width: "60px",
                                  height: "80px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                            </div>

                            {/* Product Details */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div
                                style={{
                                  fontSize: "14px",
                                  marginBottom: "4px",
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                }}
                              >
                                <strong>product Name:- </strong>{" "}
                                {item.productId?.title || item.name || "N/A"}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                <strong>Qty:</strong> {item.quantity}
                              </div>
                              <div style={{ fontSize: "13px" }}>
                                <strong>Price:</strong>
                                {formatPrice(Math.round(
                                  item?.productId?.finalPrice || item?.price
                                ), order)}
                              </div>
                              {item.productId?.ISBN13 && (
                                <div style={{ fontSize: "13px" }}>
                                  <strong>ISBN13:</strong> {item.productId.ISBN13}
                                </div>
                              )}
                            </div>
                            {/* <hr style={{border: "1px solid #130707ff", }} /> */}
                          </div>
                        ))}
                      </div>
                    </td>

                    <td className="align-middle">
                      <div className="payment-details">
                        <div>
                          <strong>Totale Amount:- </strong> {formatTotal(order)}
                        </div>
                        <div>
                          <strong>Ordet Status:- </strong> <span
                            style={{
                              display: "inline-block",
                              padding: "5px 12px",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: "500",
                              backgroundColor: order?.orderStatus === 'Cancelled' ? "#f8d7da" : order.orderStatus === 'Confirmed' ? "#d1e7dd" : "#ffffffff",
                              color: order.orderStatus === 'Cancelled' ? '#842029' : order.orderStatus === 'Confirmed' ? "#0f5132" : "#191515ff",

                            }}
                          >
                            {order?.orderStatus}
                          </span>
                        </div>
                        <div>
                          <strong>Payment Method:- </strong> {order.paymentMethod}
                        </div>
                        <div>
                          <strong>Payment Status:- </strong> {order.paymentStatus}
                        </div>
                      </div>
                    </td>
                    <td className="align-middle">
                      <div className="payment-details">
                        <span
                          style={{
                            display: "inline-block",
                            padding: "5px 12px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "500",
                            backgroundColor:
                              feedback(order?._id)?.length > 0
                                ? "#d1e7dd"
                                : "#f8d7da",
                            color:
                              feedback(order?._id)?.length > 0
                                ? "#0f5132"
                                : "#842029",
                          }}
                        >
                          {feedback(order?._id)?.length > 0 ? "True" : "False"}
                        </span>
                      </div>
                    </td>
                    <td className="align-middle">
                      <div
                        style={{
                          fontSize: "14px",
                          marginBottom: "4px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {new Date(order.createdAt).toLocaleString("en-IN", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                        })}
                      </div>
                    </td>
                    <td className="align-middle">
                      <div className="d-flex flex-column gap-2">

                        {/* Download Slip Button */}
                        <button
                          onClick={() => downloadPDF(order)}
                          className="text-sm fw-semibold"
                          style={{
                            background: "linear-gradient(90deg, #6366f1, #a855f7, #ec4899)",
                            color: "white",
                            border: "none",
                            padding: "8px 14px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <i className="fa-solid fa-download"></i>
                          Download Slip
                        </button>

                        {/* Update Button */}
                        <Link
                          to={`/order-details/${order?._id}`}
                          className="btn btn-primary btn-sm d-flex align-items-center gap-1 text-sm fw-semibold"
                          style={{ borderRadius: "8px" }}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                          Update
                        </Link>

                        {/* Status Dropdown */}
                        <select
                          className="btn btn-success btn-sm text-sm fw-semibold"
                          style={{
                            borderRadius: "8px",
                            padding: "8px 10px",
                            cursor: "pointer",
                          }}
                          // value={orderStatus}
                          onChange={(e) => handleChangeStatus(e, order)}
                        // disabled={isOrderStatusDisabled}
                        >
                          <option value=" ">Update status</option>
                          <option value="Confirmed">Order Confirmed</option>
                          <option value="Cancelled">Order Cancelled</option>
                        </select>

                      </div>
                    </td>

                  </tr>
                </>)
              })
            ) : (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No orders found.
                </td>
              </tr>
            )}
          </tbody>
          {pdfOrder &&
            < div style={{ display: "none" }}>
              <div
                ref={invoiceRef}
                style={{ padding: "20px", fontFamily: "Arial, sans-serif", maxWidth: "600px", margin: "0 auto", fontSize: "14px", lineHeight: "1.4", }}
              >
                {/* Header */}
                <div style={{ marginBottom: "15px", display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex' }}>
                    <h1 style={{ fontSize: "12px", fontWeight: "bold", margin: "5px 5px 5px 5px" }}>Ship to:</h1>
                    <div style={{ fontSize: "9px", fontWeight: "bold", margin: "0 0 0 0", marginTop: '7px' }}>
                      {pdfOrder?.shippingAddress?.firstName} {pdfOrder?.shippingAddress?.lastName}
                    </div>
                  </div>
                  <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>
                    Order ID: {pdfOrder?._id || "404-9537172-8890759"}
                  </p>
                </div>

                <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />
                {/* Delivery and Order Details Table */}
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px", fontSize: "12px" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%", verticalAlign: "top", paddingRight: "10px" }}>
                        <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>Delivery address:</p>
                        <p style={{ margin: "0 0 2px 0" }}>
                          {pdfOrder?.shippingAddress?.firstName} {pdfOrder?.shippingAddress?.lastName}
                        </p>
                        <p style={{ margin: "0 0 2px 0" }}>{pdfOrder?.shippingAddress?.phone}</p>
                        <p style={{ margin: "0 0 2px 0" }}>{pdfOrder?.shippingAddress?.address}</p>
                        <p style={{ margin: "0 0 2px 0" }}>
                          {pdfOrder?.shippingAddress?.city}, {pdfOrder?.shippingAddress?.state}{" "}
                          {pdfOrder?.shippingAddress?.postalCode}
                        </p>
                      </td>
                      <td style={{ width: "50%", verticalAlign: "top" }}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "2px 0", textAlign: "right" }}>
                                <strong>Order Date:</strong> {formatDate(pdfOrder?.createdAt)}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 0", textAlign: "right" }}>
                                <strong>Shipping Service:</strong> Standard
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 0", textAlign: "right" }}>
                                <strong>Buyer Name:</strong> {pdfOrder?.shippingAddress?.firstName}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "2px 0", textAlign: "right" }}>
                                <strong>Seller Name:</strong> DELHI BOOK STORE
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />

                {/* Product Details Table */}
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px", fontSize: "12px" }}>
                  <thead>
                    <tr>
                      {/* <th style={{ textAlign: "left", borderBottom: "1px solid #000", padding: "5px 0", width: "15%" }}>
                        Product Image
                      </th> */}
                      <th style={{ textAlign: "left", borderBottom: "1px solid #000", padding: "5px 0", width: "50%" }}>
                        Product Details
                      </th>
                      <th style={{ textAlign: "right", borderBottom: "1px solid #000", padding: "5px 0", width: "15%" }}>
                        Unit price
                      </th>
                      <th style={{ textAlign: "right", borderBottom: "1px solid #000", padding: "5px 0", width: "20%" }}>
                        Quantity
                      </th>
                      <th style={{ textAlign: "right", borderBottom: "1px solid #000", padding: "5px 0", width: "20%" }}>
                        Order Totals
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pdfOrder?.items?.map((item, index) => (
                      <tr key={index}>
                        {/* <td style={{ padding: "10px 0", verticalAlign: "top" }}>
                          <img
                            src={item?.productId?.images?.length > 0 ? `${serverURL}/public/image/${item?.productId?.images[0]}` || IMAGES : IMAGES}
                            alt={"Product"}
                            className="img-thumbnail"
                            style={{ width: "60px", height: "80px", objectFit: "cover", borderRadius: "4px", }}
                          />
                        </td> */}

                        <td style={{ padding: "10px 0", verticalAlign: "top" }}>
                          <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>
                            {item?.productId?.title || item?.productId?.productName}
                          </p>
                          <p style={{ margin: "0 0 2px 0" }}>
                            ISBN13: {`${item?.productId?.ISBN13}_DBS` || "9780814472811_DBS"}
                          </p>
                          {item?.productId?.asin && <p style={{ margin: "0 0 2px 0" }}>
                            ASIN: {item?.productId?.asin || "0814472818"}
                          </p>}
                          <p style={{ margin: "0 0 2px 0" }}>Condition: New</p>
                          <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>
                            Order Item ID: {item?._id?.substring(0, 14) || "53402259347802"}
                          </p>
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "top", padding: "5px 5px" }}>
                          {formatPrice(item?.productId?.finalPrice || item?.price || "450.00", pdfOrder)}
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "top", padding: "2px 2px" }}>
                          {item?.quantity || 1}
                        </td>
                        <td style={{ textAlign: "right", verticalAlign: "top", padding: "10px 0" }}>
                          <p style={{ margin: "0 0 0 0" }}>
                            Item total: ${formatPrice(((item?.productId?.finalPrice || item?.price || 450) * (item?.quantity || 1)), pdfOrder)}
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p style={{ margin: "5 0 5 0" }}>
                  Condition note: Fast Shipping. Excellent & friendly Customer Service. We will respond to your mails
                  within 12 hours. You will be HAPPY with your purchase. Your satisfaction is guaranteed!
                </p>
                <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />

                {/* COD Amount */}
                <div style={{ marginBottom: "15px", display: "flex", justifyContent: "space-between" }}>
                  <h3 style={{ fontSize: "16px", fontWeight: "bold", margin: "0 0 5px 0" }}>
                    COD Collectible Amount
                  </h3>
                  <p style={{ fontSize: "18px", fontWeight: "bold", margin: "0" }}>
                    {formatTotal(pdfOrder || "457.00")}
                  </p>
                </div>

                <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />

                {/* Footer */}
                <div style={{ fontSize: "12px", marginTop: "20px" }}>
                  <p style={{ margin: "0 0 10px 0" }}>
                    Thank you for choosing Delhi Book Store. For any product feedback or support, please visit our
                    website at www.delhibookstore.com.
                  </p>
                </div>
              </div>
            </div>}
        </table>
      </section >
    </>
  );
};

export default AllOrder;

// import React, { useEffect, useRef, useState } from "react";
// import axiosInstance, { serverURL } from "../../services/FetchNodeServices";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import html2pdf from "html2pdf.js";
// import CallBackImg from "../../services/DBSLOGO.jpg";
// import IMAGES from "../../services/noImage.png";

// // ─── Injected CSS (overrides Bootstrap completely) ────────────────────────────
// const PAGE_STYLES = `
//   .ao-wrap * { box-sizing: border-box; }

//   .ao-wrap {
//     font-family: 'Segoe UI', system-ui, -apple-system, sans-serif !important;
//     background: #f1f5f9 !important;
//     min-height: 100vh;
//     padding: 0 0 40px 0;
//     color: #0f172a !important;
//   }

//   /* ── Header ── */
//   .ao-header {
//     background: #fff !important;
//     border-bottom: 2px solid #e2e8f0 !important;
//     padding: 16px 28px !important;
//     display: flex !important;
//     align-items: center !important;
//     justify-content: space-between !important;
//     flex-wrap: wrap !important;
//     gap: 12px !important;
//     margin-bottom: 0 !important;
//   }
//   .ao-header h4 {
//     font-size: 20px !important;
//     font-weight: 700 !important;
//     color: #0f172a !important;
//     margin: 0 !important;
//     display: flex !important;
//     align-items: center !important;
//     gap: 8px !important;
//   }
//   .ao-count {
//     font-size: 11px !important;
//     font-weight: 600 !important;
//     background: #eff6ff !important;
//     color: #1d4ed8 !important;
//     border: 1px solid #bfdbfe !important;
//     padding: 2px 10px !important;
//     border-radius: 20px !important;
//   }

//   /* ── Controls ── */
//   .ao-controls {
//     background: #fff !important;
//     border-bottom: 1px solid #e2e8f0 !important;
//     padding: 14px 28px !important;
//     display: flex !important;
//     align-items: center !important;
//     gap: 10px !important;
//     flex-wrap: wrap !important;
//   }
//   .ao-select {
//     border: 1px solid #cbd5e1 !important;
//     border-radius: 8px !important;
//     padding: 8px 12px !important;
//     font-size: 13px !important;
//     color: #334155 !important;
//     background: #fff !important;
//     cursor: pointer !important;
//     outline: none !important;
//     min-width: 160px !important;
//     font-family: inherit !important;
//     appearance: auto !important;
//   }
//   .ao-search-wrap {
//     position: relative !important;
//     display: flex !important;
//     align-items: center !important;
//   }
//   .ao-search-icon {
//     position: absolute !important;
//     left: 10px !important;
//     color: #94a3b8 !important;
//     font-size: 12px !important;
//     pointer-events: none !important;
//   }
//   .ao-input {
//     border: 1px solid #cbd5e1 !important;
//     border-radius: 8px !important;
//     padding: 8px 12px 8px 30px !important;
//     font-size: 13px !important;
//     color: #334155 !important;
//     background: #fff !important;
//     outline: none !important;
//     width: 280px !important;
//     font-family: inherit !important;
//   }
//   .ao-btn-dl {
//     background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;
//     color: #fff !important;
//     border: none !important;
//     border-radius: 8px !important;
//     padding: 8px 16px !important;
//     font-size: 13px !important;
//     font-weight: 600 !important;
//     cursor: pointer !important;
//     display: flex !important;
//     align-items: center !important;
//     gap: 6px !important;
//     font-family: inherit !important;
//   }

//   /* ── Table wrapper ── */
//   .ao-table-wrap {
//     padding: 20px 28px !important;
//     overflow-x: auto !important;
//   }

//   /* ── Table ── */
//   .ao-table {
//     width: 100% !important;
//     border-collapse: separate !important;
//     border-spacing: 0 !important;
//     background: #fff !important;
//     border-radius: 12px !important;
//     overflow: hidden !important;
//     border: 1px solid #e2e8f0 !important;
//     font-size: 13px !important;
//     box-shadow: none !important;
//   }
//   .ao-table thead tr {
//     background: #f8fafc !important;
//   }
//   .ao-table th {
//     background: #f1f5f9 !important;
//     color: #475569 !important;
//     font-weight: 700 !important;
//     font-size: 11px !important;
//     text-transform: uppercase !important;
//     letter-spacing: 0.05em !important;
//     padding: 12px 16px !important;
//     border-bottom: 2px solid #e2e8f0 !important;
//     border-top: none !important;
//     border-left: none !important;
//     border-right: none !important;
//     white-space: nowrap !important;
//   }
//   .ao-table td {
//     padding: 14px 16px !important;
//     border-bottom: 1px solid #f1f5f9 !important;
//     border-top: none !important;
//     border-left: none !important;
//     border-right: none !important;
//     vertical-align: top !important;
//     color: #334155 !important;
//     background: transparent !important;
//   }
//   .ao-table tr:last-child td { border-bottom: none !important; }
//   .ao-table tbody tr:hover td { background: #f8fafc !important; }
//   .ao-table tbody tr:nth-child(even) td { background: #fafafa; }
//   .ao-table tbody tr:nth-child(even):hover td { background: #f1f5f9 !important; }

//   /* ── Label / Value ── */
//   .ao-label {
//     font-size: 10px !important;
//     font-weight: 700 !important;
//     color: #94a3b8 !important;
//     text-transform: uppercase !important;
//     letter-spacing: 0.06em !important;
//     display: block !important;
//     margin-bottom: 2px !important;
//   }
//   .ao-val {
//     font-size: 13px !important;
//     color: #1e293b !important;
//     word-break: break-word !important;
//   }

//   /* ── Order ID ── */
//   .ao-order-id {
//     font-size: 12px !important;
//     font-weight: 700 !important;
//     color: #6366f1 !important;
//     letter-spacing: 0.02em !important;
//   }

//   /* ── Product row ── */
//   .ao-product-row {
//     display: flex !important;
//     align-items: flex-start !important;
//     gap: 10px !important;
//     padding: 8px 0 !important;
//     border-bottom: 1px solid #f1f5f9 !important;
//   }
//   .ao-product-row:last-child { border-bottom: none !important; }
//   .ao-product-img {
//     width: 50px !important;
//     height: 66px !important;
//     object-fit: cover !important;
//     border-radius: 6px !important;
//     border: 1px solid #e2e8f0 !important;
//     flex-shrink: 0 !important;
//   }

//   /* ── Status badges ── */
//   .ao-badge {
//     display: inline-block !important;
//     padding: 3px 10px !important;
//     border-radius: 20px !important;
//     font-size: 11px !important;
//     font-weight: 600 !important;
//     letter-spacing: 0.02em !important;
//     border: 1px solid transparent !important;
//   }
//   .ao-badge-confirmed  { background: #d1fae5 !important; color: #065f46 !important; border-color: #a7f3d0 !important; }
//   .ao-badge-cancelled  { background: #fee2e2 !important; color: #991b1b !important; border-color: #fca5a5 !important; }
//   .ao-badge-pending    { background: #fef3c7 !important; color: #92400e !important; border-color: #fde68a !important; }
//   .ao-badge-shipped    { background: #dbeafe !important; color: #1e40af !important; border-color: #93c5fd !important; }
//   .ao-badge-delivered  { background: #ede9fe !important; color: #5b21b6 !important; border-color: #c4b5fd !important; }
//   .ao-badge-default    { background: #f3f4f6 !important; color: #374151 !important; border-color: #d1d5db !important; }

//   .ao-badge-paid    { background: #d1fae5 !important; color: #065f46 !important; }
//   .ao-badge-unpaid  { background: #fef3c7 !important; color: #92400e !important; }

//   .ao-badge-fb-yes  { background: #d1fae5 !important; color: #065f46 !important; border-color: #a7f3d0 !important; }
//   .ao-badge-fb-no   { background: #fee2e2 !important; color: #991b1b !important; border-color: #fca5a5 !important; }

//   /* ── Currency badge ── */
//   .ao-currency-inr { background: #fef9c3 !important; color: #854d0e !important; }
//   .ao-currency-eur { background: #dbeafe !important; color: #1e40af !important; }
//   .ao-currency-gbp { background: #d1fae5 !important; color: #065f46 !important; }
//   .ao-currency-usd { background: #e0f2fe !important; color: #075985 !important; }
//   .ao-currency-badge {
//     font-size: 10px !important;
//     padding: 2px 7px !important;
//     border-radius: 4px !important;
//     font-weight: 700 !important;
//     margin-left: 4px !important;
//     display: inline-block !important;
//   }

//   /* ── Total amount ── */
//   .ao-total {
//     font-size: 15px !important;
//     font-weight: 700 !important;
//     color: #0f172a !important;
//   }

//   /* ── Action buttons ── */
//   .ao-btn {
//     display: flex !important;
//     align-items: center !important;
//     justify-content: center !important;
//     gap: 5px !important;
//     width: 100% !important;
//     padding: 7px 12px !important;
//     border-radius: 7px !important;
//     font-size: 12px !important;
//     font-weight: 600 !important;
//     cursor: pointer !important;
//     border: none !important;
//     color: #fff !important;
//     text-decoration: none !important;
//     font-family: inherit !important;
//     margin-bottom: 6px !important;
//   }
//   .ao-btn-pdf  { background: linear-gradient(135deg, #6366f1, #a855f7) !important; }
//   .ao-btn-edit { background: #3b82f6 !important; }
//   .ao-status-select {
//     border: 1px solid #10b981 !important;
//     border-radius: 7px !important;
//     padding: 7px 10px !important;
//     font-size: 12px !important;
//     font-weight: 600 !important;
//     cursor: pointer !important;
//     background: #ecfdf5 !important;
//     color: #065f46 !important;
//     width: 100% !important;
//     outline: none !important;
//     font-family: inherit !important;
//     appearance: auto !important;
//   }

//   /* ── Empty state ── */
//   .ao-empty {
//     text-align: center !important;
//     padding: 56px 0 !important;
//     color: #94a3b8 !important;
//     font-size: 14px !important;
//   }

//   /* ── Product scroll container ── */
//   .ao-product-scroll {
//     max-height: 200px !important;
//     overflow-y: auto !important;
//     scrollbar-width: thin !important;
//     scrollbar-color: #cbd5e1 transparent !important;
//   }
// `;

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const getOrderCurrency = (order) => {
//   const currency = order?.currency || "";
//   if (currency === "INR") return "INR";
//   if (currency === "EUR") return "EUR";
//   if (currency === "GBP") return "GBP";
//   return "USD";
// };

// const formatPrice = (dollarAmount, order, decimals = 2) => {
//   const currency = getOrderCurrency(order);
//   const rate = order?.dollarPriceAtOrder || 1;
//   const amount = parseFloat(dollarAmount || 0);
//   switch (currency) {
//     case "INR": return `₹${Math.ceil(amount * rate).toLocaleString("en-IN")}`;
//     case "EUR": return `€${(amount * rate).toFixed(decimals)}`;
//     case "GBP": return `£${(amount * rate).toFixed(decimals)}`;
//     default:    return `$${amount.toFixed(decimals)}`;
//   }
// };

// const formatTotal = (order) => {
//   const currency = getOrderCurrency(order);
//   const total = parseFloat(order?.totalAmount || 0);
//   const rate  = order?.dollarPriceAtOrder || 1;
//   switch (currency) {
//     case "INR": return `₹${Math.ceil(total * rate).toLocaleString("en-IN")}`;
//     case "EUR": return `€${(total * rate).toFixed(2)}`;
//     case "GBP": return `£${(total * rate).toFixed(2)}`;
//     default:    return `$${total.toFixed(2)}`;
//   }
// };

// const formatDate = (dateString) => {
//   if (!dateString) return "N/A";
//   return new Date(dateString).toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" });
// };

// // ─── Status badge ─────────────────────────────────────────────────────────────
// const StatusBadge = ({ status }) => {
//   const cls = {
//     Confirmed: "ao-badge-confirmed",
//     Cancelled: "ao-badge-cancelled",
//     Pending:   "ao-badge-pending",
//     Shipped:   "ao-badge-shipped",
//     Delivered: "ao-badge-delivered",
//   }[status] || "ao-badge-default";
//   return <span className={`ao-badge ${cls}`}>{status || "—"}</span>;
// };

// // ─── Currency badge ───────────────────────────────────────────────────────────
// const CurrencyBadge = ({ order }) => {
//   const currency = getOrderCurrency(order);
//   const cls = { INR: "ao-currency-inr", EUR: "ao-currency-eur", GBP: "ao-currency-gbp", USD: "ao-currency-usd" }[currency] || "ao-currency-usd";
//   return <span className={`ao-currency-badge ${cls}`}>{currency}</span>;
// };

// // ─── Main ─────────────────────────────────────────────────────────────────────
// const AllOrder = () => {
//   const [orders, setOrders]                 = useState([]);
//   const [pdfOrder, setPdfOrder]             = useState(null);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [searchQuery, setSearchQuery]       = useState("");
//   const [filterOption, setFilterOption]     = useState("");
//   const [selectedOrders, setSelectedOrders] = useState([]);
//   const [selectAll, setSelectAll]           = useState(false);
//   const [reviews, setReviews]               = useState([]);
//   const invoiceRef = useRef(null);

//   // ── Fetch ──────────────────────────────────────────────────────────────────
//   const fetchOrders = async () => {
//     try {
//       const response = await axiosInstance.get("/api/v1/order/get-all-orders-admin");
//       if (response.status === 200) {
//         const reversed = response?.data.orders?.reverse();
//         setOrders(reversed);
//         setFilteredOrders(reversed);
//       }
//     } catch (error) {
//       toast.error("Failed to fetch orders.");
//     }
//   };

//   useEffect(() => { fetchOrders(); }, []);

//   useEffect(() => {
//     const fetchReviews = async () => {
//       try {
//         const response = await axiosInstance.get("/api/v1/feedback/get-all-feedback");
//         if (response?.data?.success) setReviews(response?.data?.feedback || []);
//       } catch (error) { /* silent */ }
//     };
//     fetchReviews();
//   }, []);

//   // ── Filter by date ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     let filtered = [...orders];
//     const today = new Date();
//     if (filterOption === "today") {
//       filtered = filtered.filter((o) => new Date(o.createdAt).toDateString() === today.toDateString());
//     } else if (filterOption === "yesterday") {
//       const y = new Date(); y.setDate(today.getDate() - 1);
//       filtered = filtered.filter((o) => new Date(o.createdAt).toDateString() === y.toDateString());
//     } else if (filterOption === "thisWeek") {
//       const s = new Date(); s.setDate(today.getDate() - today.getDay());
//       filtered = filtered.filter((o) => new Date(o.createdAt) >= s);
//     } else if (filterOption === "thisMonth") {
//       const s = new Date(today.getFullYear(), today.getMonth(), 1);
//       filtered = filtered.filter((o) => new Date(o.createdAt) >= s);
//     } else if (filterOption === "thisYear") {
//       const s = new Date(today.getFullYear(), 0, 1);
//       filtered = filtered.filter((o) => new Date(o.createdAt) >= s);
//     }
//     setFilteredOrders(filtered);
//   }, [filterOption, orders]);

//   // ── Search ─────────────────────────────────────────────────────────────────
//   const handleSearch = (e) => {
//     const query = e.target.value?.toLowerCase();
//     setSearchQuery(query);
//     setFilteredOrders(orders.filter((order) =>
//       order.orderUniqueId?.toLowerCase().includes(query) ||
//       order.shippingAddress?.email?.toLowerCase().includes(query) ||
//       order.shippingAddress?.firstName?.toLowerCase().includes(query) ||
//       order.shippingAddress?.lastName?.toLowerCase().includes(query)
//     ));
//   };

//   // ── Checkbox ───────────────────────────────────────────────────────────────
//   const handleSelectOrder = (id) =>
//     setSelectedOrders((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);

//   const handleSelectAll = () => {
//     setSelectedOrders(selectAll ? [] : filteredOrders.map((o) => o._id));
//     setSelectAll(!selectAll);
//   };

//   // ── Delete ─────────────────────────────────────────────────────────────────
//   const deleteOrder = async (orderId) => {
//     const conf = await Swal.fire({ title: "Are you sure?", text: "This cannot be undone!", icon: "warning", showCancelButton: true, confirmButtonText: "Yes, delete it!" });
//     if (conf.isConfirmed) {
//       try {
//         const res = await axiosInstance.delete(`/api/v1/order/delete-order/${orderId}`);
//         if (res?.status === 200) {
//           const updated = orders.filter((o) => o._id !== orderId);
//           setOrders(updated); setFilteredOrders(updated);
//           setSelectedOrders((prev) => prev.filter((id) => id !== orderId));
//           toast.success("Order deleted.");
//         }
//       } catch { toast.error("Failed to delete order."); }
//     }
//   };

//   // ── Status update ──────────────────────────────────────────────────────────
//   const handleChangeStatus = async (e, order) => {
//     try {
//       await axiosInstance.put(`/api/v1/order/update-order/${order?._id}`, { orderStatus: e.target.value });
//       fetchOrders();
//       toast.success("Status updated.");
//     } catch { toast.error("Failed to update status."); }
//   };

//   // ── Download XLSX ──────────────────────────────────────────────────────────
//   const handleDownloadSelected = () => {
//     const selectedData = orders.filter((o) => selectedOrders.includes(o._id));
//     if (!selectedData.length) { toast.warn("Select at least one order."); return; }

//     const formattedData = [];
//     let counter = 1;
//     selectedData.forEach((order) => {
//       (order.items || []).forEach((item) => {
//         const isbn13 = item.productId?.ISBN13 || item.ISBN13 || "N/A";
//         formattedData.push({
//           "S.No.": counter++,
//           "purchase-date": new Date(order?.createdAt).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }).toUpperCase().replace(",", ""),
//           "PLATFORM": order.platform || "Delhi Bookstore",
//           "QTY": item.quantity || 1,
//           "order-id": order.orderUniqueId || order._id,
//           "product-name": item.productId?.title || item.name || "N/A",
//           "ISBN-13": isbn13,
//           "sku": isbn13 !== "N/A" ? `${isbn13}_DBS` : "N/A",
//           "currency": getOrderCurrency(order),
//           "item-price": formatPrice(item?.productId?.finalPrice || item?.price || "0", order),
//           "shipping-price": item.shippingPrice || 0,
//           "buyer-name": `${order.shippingAddress?.firstName || ""} ${order.shippingAddress?.lastName || ""}`.trim() || "N/A",
//           "recipient-name": `${order.shippingAddress?.firstName || ""} ${order.shippingAddress?.lastName || ""}`.trim() || "N/A",
//           "ship-address-1": order.shippingAddress?.address || "",
//           "ship-address-2": order.shippingAddress?.address2 || "",
//           "ship-city": order.shippingAddress?.city || "",
//           "ship-state": order.shippingAddress?.state || "",
//           "ship-postal-code": order.shippingAddress?.zipCode || order.shippingAddress?.postalCode || "",
//           "ship-country": order.shippingAddress?.country || "IN",
//           "buyer-phone-number": order.shippingAddress?.phone || "",
//           "ship-phone-number": order.shippingAddress?.phone || "",
//           "buyer-email": order.shippingAddress?.email || "",
//         });
//       });
//     });

//     const ws = XLSX.utils.json_to_sheet(formattedData);
//     ws["!cols"] = [{ wch: 8 }, { wch: 16 }, { wch: 16 }, { wch: 6 }, { wch: 28 }, { wch: 70 }, { wch: 16 }, { wch: 20 }, { wch: 10 }, { wch: 14 }, { wch: 14 }, { wch: 22 }, { wch: 22 }, { wch: 35 }, { wch: 25 }, { wch: 18 }, { wch: 18 }, { wch: 16 }, { wch: 10 }, { wch: 18 }, { wch: 18 }, { wch: 35 }];
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Orders");
//     saveAs(new Blob([XLSX.write(wb, { bookType: "xlsx", type: "array" })], { type: "application/octet-stream" }), `Orders_${Date.now()}.xlsx`);
//   };

//   // ── PDF ────────────────────────────────────────────────────────────────────
//   const downloadPDF = (order) => {
//     setPdfOrder(order);
//     setTimeout(() => {
//       html2pdf().set({
//         margin: 0.5,
//         filename: `${order.shippingAddress.firstName} ${order.shippingAddress.lastName} - ${formatDate(order.createdAt)}.pdf`,
//         html2canvas: { scale: 2 },
//         jsPDF: { unit: "in", format: "a4" },
//       }).from(invoiceRef.current).save();
//     }, 200);
//   };

//   const feedback = (id) => reviews.filter((item) => item?.orderId?._id === id);

//   // ── Render ─────────────────────────────────────────────────────────────────
//   return (
//     <>
//       {/* Inject CSS */}
//       <style>{PAGE_STYLES}</style>
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="ao-wrap">

//         {/* Header */}
//         <div className="ao-header">
//           <h4>
//             <i className="fa-solid fa-box-open" style={{ color: "#6366f1" }}></i>
//             All Orders
//             <span className="ao-count">{filteredOrders.length} orders</span>
//           </h4>
//         </div>

//         {/* Controls */}
//         <div className="ao-controls">
//           <select className="ao-select" value={filterOption} onChange={(e) => setFilterOption(e.target.value)}>
//             <option value="">All Orders</option>
//             <option value="today">Today</option>
//             <option value="yesterday">Yesterday</option>
//             <option value="thisWeek">This Week</option>
//             <option value="thisMonth">This Month</option>
//             <option value="thisYear">This Year</option>
//           </select>

//           <div className="ao-search-wrap">
//             <i className="fa-solid fa-magnifying-glass ao-search-icon"></i>
//             <input
//               className="ao-input"
//               type="text"
//               placeholder="Search by Order ID, Name or Email..."
//               value={searchQuery}
//               onChange={handleSearch}
//             />
//           </div>

//           <button className="ao-btn-dl" onClick={handleDownloadSelected}>
//             <i className="fa-solid fa-download"></i>
//             Download Selected ({selectedOrders.length})
//           </button>
//         </div>

//         {/* Table */}
//         <div className="ao-table-wrap">
//           <table className="ao-table">
//             <thead>
//               <tr>
//                 <th style={{ width: 40 }}>
//                   <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
//                 </th>
//                 <th style={{ width: 46 }}>#</th>
//                 <th>Order Info</th>
//                 <th>Products</th>
//                 <th>Payment</th>
//                 <th>Feedback</th>
//                 <th>Date</th>
//                 <th style={{ width: 150 }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredOrders?.length > 0 ? filteredOrders.map((order, index) => (
//                 <tr key={order?._id}>

//                   {/* Checkbox */}
//                   <td style={{ textAlign: "center", verticalAlign: "middle" }}>
//                     <input type="checkbox" checked={selectedOrders.includes(order._id)} onChange={() => handleSelectOrder(order._id)} />
//                   </td>

//                   {/* Index */}
//                   <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: 600, color: "#94a3b8" }}>
//                     {index + 1}
//                   </td>

//                   {/* Order Info */}
//                   <td style={{ minWidth: 210 }}>
//                     <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
//                       <div>
//                         <span className="ao-label">Order ID</span>
//                         <span className="ao-order-id">{order.orderUniqueId}</span>
//                       </div>
//                       <div>
//                         <span className="ao-label">Customer</span>
//                         <span className="ao-val">{order.shippingAddress?.firstName} {order.shippingAddress?.lastName}</span>
//                       </div>
//                       <div>
//                         <span className="ao-label">Email</span>
//                         <span className="ao-val" style={{ fontSize: 12 }}>{order.shippingAddress?.email || "—"}</span>
//                       </div>
//                       <div>
//                         <span className="ao-label">Phone</span>
//                         <span className="ao-val">{order.shippingAddress?.phone || "—"}</span>
//                       </div>
//                       <div>
//                         <span className="ao-label">Address</span>
//                         <span className="ao-val" style={{ fontSize: 12 }}>
//                           {order.shippingAddress?.address}, {order.shippingAddress?.city}, {order.shippingAddress?.state} {order.shippingAddress?.zipCode}
//                         </span>
//                       </div>
//                     </div>
//                   </td>

//                   {/* Products */}
//                   <td style={{ minWidth: 260, maxWidth: 300 }}>
//                     <div className="ao-product-scroll">
//                       {order.items?.map((item, idx) => (
//                         <div key={idx} className="ao-product-row">
//                           <img
//                             className="ao-product-img"
//                             src={item?.productId?.images?.length > 0 ? `${serverURL}/public/image/${item?.productId?.images[0]}` : IMAGES}
//                             alt="Product"
//                             onError={(e) => { e.target.src = IMAGES; }}
//                           />
//                           <div style={{ flex: 1, minWidth: 0 }}>
//                             <div style={{ fontSize: 13, fontWeight: 600, color: "#1e293b", marginBottom: 3, wordBreak: "break-word" }}>
//                               {item.productId?.title || item.name || "N/A"}
//                             </div>
//                             <div style={{ fontSize: 12, color: "#64748b" }}>Qty: <strong>{item.quantity}</strong></div>
//                             <div style={{ fontSize: 12, color: "#64748b" }}>
//                               Price: <strong style={{ color: "#0f172a" }}>{formatPrice(item?.productId?.finalPrice || item?.price, order)}</strong>
//                             </div>
//                             {item.productId?.ISBN13 && (
//                               <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>ISBN: {item.productId.ISBN13}</div>
//                             )}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </td>

//                   {/* Payment */}
//                   <td style={{ minWidth: 170 }}>
//                     <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
//                       <div>
//                         <span className="ao-label">Total</span>
//                         <span className="ao-total">
//                           {formatTotal(order)}<CurrencyBadge order={order} />
//                         </span>
//                       </div>
//                       <div>
//                         <span className="ao-label">Order Status</span>
//                         <StatusBadge status={order?.orderStatus} />
//                       </div>
//                       <div>
//                         <span className="ao-label">Method</span>
//                         <span className="ao-val">{order.paymentMethod || "—"}</span>
//                       </div>
//                       <div>
//                         <span className="ao-label">Payment</span>
//                         <span className={`ao-badge ${order.paymentStatus === "Paid" ? "ao-badge-paid" : "ao-badge-unpaid"}`}>
//                           {order.paymentStatus || "—"}
//                         </span>
//                       </div>
//                     </div>
//                   </td>

//                   {/* Feedback */}
//                   <td style={{ textAlign: "center", verticalAlign: "middle" }}>
//                     {feedback(order?._id)?.length > 0
//                       ? <span className="ao-badge ao-badge-fb-yes">✓ Yes</span>
//                       : <span className="ao-badge ao-badge-fb-no">✗ No</span>
//                     }
//                   </td>

//                   {/* Date */}
//                   <td style={{ minWidth: 110, verticalAlign: "middle" }}>
//                     <div style={{ fontSize: 12, color: "#475569", fontWeight: 500 }}>
//                       {new Date(order.createdAt).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" })}
//                     </div>
//                     <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3 }}>
//                       {new Date(order.createdAt).toLocaleTimeString("en-IN", { hour: "numeric", minute: "numeric", hour12: true })}
//                     </div>
//                   </td>

//                   {/* Actions */}
//                   <td style={{ verticalAlign: "middle" }}>
//                     <button onClick={() => downloadPDF(order)} className="ao-btn ao-btn-pdf">
//                       <i className="fa-solid fa-download" style={{ fontSize: 11 }}></i> Slip
//                     </button>
//                     <Link to={`/order-details/${order?._id}`} className="ao-btn ao-btn-edit">
//                       <i className="fa-solid fa-pen-to-square" style={{ fontSize: 11 }}></i> Update
//                     </Link>
//                     <select className="ao-status-select" defaultValue="" onChange={(e) => handleChangeStatus(e, order)}>
//                       <option value="" disabled>Change Status</option>
//                       <option value="Confirmed">Confirmed</option>
//                       <option value="Shipped">Shipped</option>
//                       <option value="Delivered">Delivered</option>
//                       <option value="Cancelled">Cancelled</option>
//                     </select>
//                   </td>

//                 </tr>
//               )) : (
//                 <tr>
//                   <td colSpan={8} className="ao-empty">
//                     <i className="fa-solid fa-box-open" style={{ fontSize: 36, display: "block", marginBottom: 10, color: "#cbd5e1" }}></i>
//                     No orders found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Hidden PDF */}
//         {pdfOrder && (
//           <div style={{ display: "none" }}>
//             <div ref={invoiceRef} style={{ padding: "20px", fontFamily: "Arial, sans-serif", maxWidth: "600px", margin: "0 auto", fontSize: "14px", lineHeight: "1.4" }}>
//               <div style={{ marginBottom: "15px", display: "flex", justifyContent: "space-between" }}>
//                 <div style={{ display: "flex" }}>
//                   <h1 style={{ fontSize: "12px", fontWeight: "bold", margin: "5px" }}>Ship to:</h1>
//                   <div style={{ fontSize: "9px", fontWeight: "bold", marginTop: "7px" }}>{pdfOrder?.shippingAddress?.firstName} {pdfOrder?.shippingAddress?.lastName}</div>
//                 </div>
//                 <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>Order ID: {pdfOrder?._id}</p>
//               </div>
//               <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />
//               <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px", fontSize: "12px" }}>
//                 <tbody>
//                   <tr>
//                     <td style={{ width: "50%", verticalAlign: "top", paddingRight: "10px" }}>
//                       <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>Delivery address:</p>
//                       <p style={{ margin: "0 0 2px 0" }}>{pdfOrder?.shippingAddress?.firstName} {pdfOrder?.shippingAddress?.lastName}</p>
//                       <p style={{ margin: "0 0 2px 0" }}>{pdfOrder?.shippingAddress?.phone}</p>
//                       <p style={{ margin: "0 0 2px 0" }}>{pdfOrder?.shippingAddress?.address}</p>
//                       <p style={{ margin: "0 0 2px 0" }}>{pdfOrder?.shippingAddress?.city}, {pdfOrder?.shippingAddress?.state} {pdfOrder?.shippingAddress?.postalCode}</p>
//                     </td>
//                     <td style={{ width: "50%", verticalAlign: "top" }}>
//                       <table style={{ width: "100%" }}>
//                         <tbody>
//                           <tr><td style={{ padding: "2px 0", textAlign: "right" }}><strong>Order Date:</strong> {formatDate(pdfOrder?.createdAt)}</td></tr>
//                           <tr><td style={{ padding: "2px 0", textAlign: "right" }}><strong>Shipping Service:</strong> Standard</td></tr>
//                           <tr><td style={{ padding: "2px 0", textAlign: "right" }}><strong>Buyer Name:</strong> {pdfOrder?.shippingAddress?.firstName}</td></tr>
//                           <tr><td style={{ padding: "2px 0", textAlign: "right" }}><strong>Seller Name:</strong> DELHI BOOK STORE</td></tr>
//                         </tbody>
//                       </table>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//               <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />
//               <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px", fontSize: "12px" }}>
//                 <thead>
//                   <tr>
//                     <th style={{ textAlign: "left", borderBottom: "1px solid #000", padding: "5px 0", width: "50%" }}>Product Details</th>
//                     <th style={{ textAlign: "right", borderBottom: "1px solid #000", padding: "5px 0", width: "15%" }}>Unit Price</th>
//                     <th style={{ textAlign: "right", borderBottom: "1px solid #000", padding: "5px 0", width: "15%" }}>Qty</th>
//                     <th style={{ textAlign: "right", borderBottom: "1px solid #000", padding: "5px 0", width: "20%" }}>Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {pdfOrder?.items?.map((item, index) => (
//                     <tr key={index}>
//                       <td style={{ padding: "10px 0", verticalAlign: "top" }}>
//                         <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>{item?.productId?.title || item?.productId?.productName}</p>
//                         <p style={{ margin: "0 0 2px 0" }}>ISBN13: {item?.productId?.ISBN13 ? `${item.productId.ISBN13}_DBS` : "N/A"}</p>
//                         {item?.productId?.asin && <p style={{ margin: "0 0 2px 0" }}>ASIN: {item?.productId?.asin}</p>}
//                         <p style={{ margin: "0 0 2px 0" }}>Condition: New</p>
//                         <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>Order Item ID: {item?._id?.substring(0, 14)}</p>
//                       </td>
//                       <td style={{ textAlign: "center", verticalAlign: "top", padding: "5px" }}>{formatPrice(item?.productId?.finalPrice || item?.price || "0", pdfOrder)}</td>
//                       <td style={{ textAlign: "center", verticalAlign: "top", padding: "2px" }}>{item?.quantity || 1}</td>
//                       <td style={{ textAlign: "right", verticalAlign: "top", padding: "10px 0" }}>
//                         {formatPrice((item?.productId?.finalPrice || item?.price || 0) * (item?.quantity || 1), pdfOrder)}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               <p style={{ margin: "5px 0" }}>Condition note: Fast Shipping. Excellent &amp; friendly Customer Service. We respond within 12 hours. Your satisfaction is guaranteed!</p>
//               <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />
//               <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
//                 <h3 style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}>COD Collectible Amount</h3>
//                 <p style={{ fontSize: "18px", fontWeight: "bold", margin: 0 }}>{formatTotal(pdfOrder)}</p>
//               </div>
//               <hr style={{ borderTop: "1px dashed #000", margin: "15px 0" }} />
//               <div style={{ fontSize: "12px", marginTop: "20px" }}>
//                 <p style={{ margin: "0 0 10px 0" }}>Thank you for choosing Delhi Book Store. Visit www.delhibookstore.com for support.</p>
//               </div>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// };

// export default AllOrder;